import { PDFDocument, StandardFonts, rgb } from 'pdf-lib'
import fontkit from '@pdf-lib/fontkit'

import TrebuchetBold from './fonts/trebuchet-bold.ttf'
import TrebuchetNormal from './fonts/trebuchet-normal.ttf'
import SOATemplate from './template-jan-30-26.pdf'
import computeXBasedOnAlignment from '../computeXBasedOnAlignment'

import netBillingToWords from '../netBillingToWords'
import urlToBlob from 'utils/urlToBlob'
import { format } from 'date-fns'
import generateCutoff from 'utils/generateCutoff'

let templateMap = {
    billed_to: {
        x: 50,
        y: 620,
        size: 10,
        fontWeight: 'bold'
    },
    store: {
        x: 50,
        y: 607,
        size: 10
    },

    amount_in_words: {
        x: 340,
        y: 460,
        size: 10,
        width: 200,
        maxWidth: 200,
        fontColor: 'white',
        fontWeight: 'bold',
        wordBreaks: [" "],
        alignment: 'center',

        lineHeight: 10,
    },

    cutoff: {
        x: 320,
        y: 540,
        size: 11,
        width: 242,
        alignment: 'center',
        fontColor: 'white'
    },


    /*
    total_billing: {
        x: 452,
        y: 509,
        size: 10,
        alignment: 'right',
        width: 80
    },

    salary_deduction: {
        x: 452,
        y: 497,
        size: 10,
        alignment: 'right',
        width: 80
    },

    meal_allowance: {
        x: 452,
        y: 484,
        size: 10,
        alignment: 'right',
        width: 80
    },
    */

    net_billing: {
        x: 31,
        y: 442,
        size: 15,
        alignment: 'right',
        width: 238,
        fontWeight: 'bold'
    },

    date: {
        x: 450,
        y: 623,
        size: 10
    },

    date_settlement: {
        x: 270,
        y: 315,
        size: 10,
    },

    gross_billing: {
        x: 103,
        y: 584,
        size: 10,
        width: 174,
        alignment: 'right'
    },
    admin_cost: {
        x: 103,
        y: 570,
        size: 10,
        alignment: 'right',
        width: 174
    },
    rebate: {
        x: 103,
        y: 553,
        size: 10,
        alignment: 'right',
        width: 174
    },

    sum_billing: {
        x: 104,
        y: 540,
        size: 10,
        alignment: 'right',
        width: 174
    },
    vat: {
        x: 103,
        y: 527,
        size: 10,
        alignment: 'right',
        width: 174
    },

    withholding_tax: {
        x: 103,
        y: 514,
        size: 10,
        alignment: 'right',
        width: 174
    },
    net_billing_computed: {
        x: 103,
        y: 503,
        size: 10,
        alignment: 'right',
        width: 174,
    },

    meal_allowance: {
        x: 103,
        y: 490,
        size: 10,
        alignment: 'right',
        width: 174
    },

    salary_deduction: {
        x: 103,
        y: 476,
        size: 10,
        alignment: 'right',
        width: 174
    },

    other_deductions: {
        x: 103,
        y: 462,
        size: 10,
        alignment: 'right',
        width: 174
    },




    /*
    denomination: {
        x: 21,
        y: 441,
        size: 15,
        fontWeight: 'bold'
    },
    */

    soa_number: {
        x: 450,
        y: 635,
        size: 10,
        fontWeight: 'bold'
    },

    director_finance_dept: {
        x: 323,
        y: 160,
        size: 10,
        fontWeight: 'bold'
    },

    president: {
        x: 52,
        y: 160,
        size: 10,
        fontWeight: 'bold'
    },

    payroll_head: {
        x: 52,
        y: 245,
        size: 10,
        fontWeight: 'bold'
    },
    payroll_manager: {
        x: 323,
        y: 245,
        size: 10,
        fontWeight: 'bold'
    }





    /*
    vat: {
        x: 10,
        y: 10,
    },
    withholding_tax: {
        x: 10,
        y: 10
    }*/
}



export default async function generateSOA7star(billingDetails = {}) {
    let amountInWords = await netBillingToWords(billingDetails.net_billing || 0)

    let newBillingDetails = {
        ...billingDetails,
        amount_in_words: amountInWords,
        date: format(billingDetails.createdAt, 'MMMM dd, yyyy'),
        denomination: "PHP",
        cutoff: generateCutoff(billingDetails.payroll_from, billingDetails.payroll_to) 
    }

    console.log('newBillingDetails', newBillingDetails)
    try {
        let downloadedPDF = await urlToBlob(SOATemplate)
        let downloadedPDFBlob = await downloadedPDF.arrayBuffer()
        const templateDoc = await PDFDocument.load(downloadedPDFBlob)
        templateDoc.registerFontkit(fontkit)
        const downloadedBoldFont = await (await urlToBlob(TrebuchetBold)).arrayBuffer()
        const downloadedNormalFont = await (await urlToBlob(TrebuchetNormal)).arrayBuffer()

        const boldFont = await templateDoc.embedFont(downloadedBoldFont)
        const normalFont = await templateDoc.embedFont(downloadedNormalFont)

        let pages = templateDoc.getPages()
        let firstPage = pages[0]

        Object.keys(newBillingDetails).forEach((key) => {
            let mappingDetails = templateMap[key]

            if (mappingDetails) {
                let text = String(newBillingDetails[key])

                if (typeof newBillingDetails[key] === 'number') {
                    text = Number(newBillingDetails[key]).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                }

                //draw background color first


                let font = mappingDetails.fontWeight === 'bold' ? boldFont : normalFont
                let textWidth = mappingDetails.fontWeight === 'bold' ? boldFont.widthOfTextAtSize(text, mappingDetails.size) : normalFont.widthOfTextAtSize(text, mappingDetails.size)
                let x = computeXBasedOnAlignment(mappingDetails.alignment, mappingDetails.x, textWidth, mappingDetails.width)

                console.log(`Drawing text "${text}" at x: ${x}, y: ${mappingDetails.y}, fontSize: ${mappingDetails.size}, fontWeight: ${mappingDetails.fontWeight}, width: ${mappingDetails.width}`)

                if (mappingDetails?.backgroundColor) {
                    firstPage.drawRectangle({
                        ...mappingDetails,
                        width: textWidth,
                        height: mappingDetails.size,
                        color: mappingDetails.backgroundColor
                    })
                }
                if (mappingDetails?.fontColor === 'white')
                    firstPage.setFontColor(rgb(1, 1, 1))
                else
                    firstPage.setFontColor(rgb(0, 0, 0))

                firstPage.drawText(text, {
                    ...mappingDetails,
                    x: x,
                    font: font
                })




                //for debugging purposes

                /*
               
                if (mappingDetails.alignment === 'right' || mappingDetails.alignment === 'center') {
                    console.log('right alignment', key)



                    firstPage.drawRectangle({
                        ...mappingDetails,
                        height: 10,
                        width: textWidth,
                        borderColor: rgb(0, 1, 0),
                        borderWidth: 2
                    })

                    firstPage.drawRectangle({
                        ...mappingDetails,
                        height: 10,
                        borderColor: rgb(1, 0, 0),
                    })
                }*/




            }
        })




        const pdfBytes = await templateDoc.save()

        let blob = new Blob([pdfBytes], {
            type: 'application/pdf'
        });

        let blobURL = `${URL.createObjectURL(blob)}`;

        window.open(blobURL)
        fetch(blobURL)

    } catch (err) {
        console.log(err)
    }
}